export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-4386466.403ea140.jpg";